import { Injectable } from '@angular/core';
import { WidgetAnalyticsService } from './widget-analytics.service';
import { Observable } from 'rxjs';
import { AnalyticResponseModel } from './models/analytic-response.model';
import { DeveloperAnalyticModel } from './models/developer-analytic.model';

@Injectable({
  providedIn: 'root',
})
export class WidgetAuthService {
  constructor(private analyticsService: WidgetAnalyticsService) {}

  /**
   * Validates a developer's widget access.
   */
  authDeveloper(analytic: DeveloperAnalyticModel): Observable<AnalyticResponseModel> {
    return this.analyticsService.sendAnalytic(analytic);
  }

  /**
   * Validate a user's widget access.
   */
  authUser(analyticId: string): Observable<AnalyticResponseModel> {
    return this.analyticsService.getAnalytic(analyticId);
  }
}
